import { Box } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import React, { useEffect, Suspense } from "react";
import { getToken, messaging } from "./Controllers/firebase.config";
import { UPDATE } from "./Controllers/ApiControllers";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import admin from "./Controllers/admin";
import "/src/App.css";
import Loading from "./Components/Loading";
import ErrorBoundary from "./ErrorBoundary";
import moment from "moment";
import Topbar from "./Global/Topbar";
import useHasPermission from "./Hooks/HasPermission";
const Dashboard = React.lazy(() => import("./Global/Dashboard"));
// const Topbar = React.lazy(() => import("./Global/Topbar"));
const Login = React.lazy(() => import("./Pages/Login"));
const LoginDev = React.lazy(() => import("./Pages/LoginDev"));
const Sidebar = React.lazy(() => import("./Global/Sidebar"));
const QueueList = React.lazy(() => import("./Pages/Checkin/Queue"));
const updateUser = async (fcmid) => {
  await UPDATE(admin.token, "update_user", { id: admin.id, web_fcm: fcmid });
  localStorage.setItem("webfcm", fcmid);
};
function hasExpiredUser(timestamp) {
  const currentTime = moment().valueOf();
  return currentTime > timestamp;
}
export default function App() {
  const location = useLocation();
  const { isLoading } = useHasPermission();
  const requestPermission = async () => {
    try {
      if (!("serviceWorker" in navigator)) {
        console.error("Service workers are not supported in this browser.");
        return;
      }
      if (!("Notification" in window)) {
        console.error("This browser does not support notifications.");
        return;
      }
      const permission = await Notification.requestPermission();

      if (permission === "granted") {
        // Reuse the SW already registered in main.jsx at /admin/.
        // Without serviceWorkerRegistration the Firebase SDK falls back to
        // registering its own SW at the site root (/firebase-messaging-sw.js)
        // which 404s because the app is served from /admin/.
        const swReg = await navigator.serviceWorker.ready;
        const token = await getToken(messaging, {
          vapidKey: import.meta.env.VITE_FIREBASE_FCM_PUBLIC_KEY,
          serviceWorkerRegistration: swReg,
        });
        if (admin) {
          updateUser(token);
        }
      } else {
        console.error("Notification permission denied.");
      }
    } catch (error) {
      console.error("An error occurred while requesting permission:", error);
    }
  };
  useEffect(() => {
    admin && requestPermission();
  }, []);
  useEffect(() => {
    if (admin) {
      if (hasExpiredUser(admin.exp)) {
        localStorage.removeItem("admin");
        window.location.reload();
      }
    }
  }, []);
  useEffect(() => {
    if (!navigator.geolocation) {
      return;
    }

    navigator.geolocation.getCurrentPosition(
      () => {
        // Coordinates obtained — nothing to log in production. If you need
        // them, read position.coords here.
      },
      (error) => {
        // 1 = PERMISSION_DENIED → user choice, not a bug. Silence it.
        if (error.code === 1) {
          return;
        }
        if (error.code === 2) {
          console.log("Error: Location information is unavailable.");
        } else {
          console.log("Error:", error.message);
        }
      }
    );
  }, []);
  return (
    <ErrorBoundary>
      {" "}
      <Suspense fallback={<Loading />}>
        {" "}
        {location.pathname === "/queue" ? (
          <QueueList />
        ) : location.pathname === "/login/dev" ? (
          // Dev login con impersonate opcional. Bypassa el flag `admin`
          // para que se pueda re-loguear como otro user aun teniendo sesión.
          <LoginDev />
        ) : admin ? (
          <Box display={"flex"} width={"100%"}>
            {" "}
            <Box>
              {" "}
              <Sidebar />{" "}
            </Box>{" "}
            <Box
              id="main-scroll-container"
              maxH={"100vh"}
              overflow={"scroll"}
              w={"100vw"}
              overflowX={"hidden"}
            >
              {isLoading ? (
                <Loading />
              ) : (
                <>
                  <Topbar /> <Dashboard />{" "}
                </>
              )}{" "}
            </Box>{" "}
          </Box>
        ) : (
          <Login />
        )}{" "}
        <ReactQueryDevtools initialIsOpen={false} />{" "}
      </Suspense>{" "}
    </ErrorBoundary>
  );
}
